'use client';

import { HttpLink } from '@apollo/client';
import {
  ApolloNextAppProvider,
  ApolloClient,
  InMemoryCache,
} from '@apollo/experimental-nextjs-app-support';
import React from 'react';

/**
 * @name makeClient
 * @description Creates an Apollo client
 * @returns {ApolloClient<import('@apollo/client').NormalizedCacheObject>} Apollo client instance
 */
const makeClient = () => {
  const httpLink = new HttpLink({
    uri: '/graphql/',
    fetchOptions: { cache: 'no-store' },
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: httpLink,
  });
};

/**
 * @name ApolloWrapper
 * @param {*} props - props.children
 * @param {React} props.children - children
 * @returns {JSX.Element} JSX.Element
 */
const ApolloWrapper = ({ children }) => (
  <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>
);

export { ApolloWrapper };
